import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fAuth, firebaseApp } from "../config/firebase";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useAuthContext } from "../hooks/useAuth";
import useLoaderContext from "../hooks/useLoading";
import { useHttpsCallable } from "react-firebase-hooks/functions";
import { getFunctions } from "firebase/functions";
import { handleUserLoginCode } from "../utils/helpers";
import {
  checkIfProvidedEmailHadAdminAccess,
  getAdminEmail,
} from "../utils/firestoreHelpers";

const Login = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoaderContext();
  const { authed, setAuthed } = useAuthContext();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [isChanges, setIsChanged] = useState(false);
  const [
    sendResetPasswordEmail,
    sendResetPasswordEmailExecuting,
    sendResetPasswordEmailFunctionError,
  ] = useHttpsCallable(getFunctions(firebaseApp), "sendResetPasswordEmail");

  const onSubmit = async (e) => {
    e.preventDefault();
    let isAdmin = await checkIfProvidedEmailHadAdminAccess(email);
    if (!isAdmin) {
      setError("Not authorized");
      return;
    }
    setLoading(true);
    try {
      const user = await signInWithEmailAndPassword(fAuth, email, password);
      handleUserLoginCode();
      setAuthed(true);
    }catch (e) {
      console.log({ e });

      switch (e.code) {
        case "auth/wrong-password":
          setError("Incorrect password. Please try again.");
          break;
        case "auth/user-not-found":
          setError("No account found with this email.");
          break;
        case "auth/invalid-email":
          setError("Invalid email address.");
          break;
        case "auth/too-many-requests":
          setError("Too many failed attempts. Please try again later.");
          break;
        default:
          setError("Login failed. Please try again.");
      }
    }
    finally {
      setLoading(false);
    }
  };

  const sendPasswordResetLink = async (e) => {
    e.preventDefault();
    try {
      // if joined, send password reset link
      setLoading(true);
      let email = await getAdminEmail();
      if (email === null) {
        alert("Something went wrong");
        return;
      }
      let res = await sendResetPasswordEmail({ email: email });
      // console.log("reset password res :: ", res);
      if (!res["error"]) {
        setIsChanged(true);
      } else {
        setError("Failed to send password reset link");
      }
    } catch (error) {
      setError("Catch block : Failed to send password reset link");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authed) navigate("/dashboard/business");
  }, [authed, navigate]);

  return (
    <>
      <Form
        className="form-signin w-50 m-auto  d-flex align-items-center justify-content-center flex-column"
        style={{
          minHeight: "calc(100vh - 50px)",
        }}
      >
        <Form.Group className="mb-3 w-100" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3 w-100" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <p className="text-danger small">{error}</p>  
        <Button
          className="w-100"
          variant="primary"
          type="submit"
          onClick={onSubmit}
          style={{
            background:
              "linear-gradient(270deg, rgb(255, 208, 115) 25%, rgb(213, 162, 62) 50%, rgb(179, 130, 36) 75%)",
            border: 0,
          }}
        >
          Log In
        </Button>
        {/* <div className="link">Forgot Password ?</div> */}
        <p
          style={{ cursor: "pointer" }}
          className="mt-3 link-opacity-100 pointer"
          // onClick={() => navigate("/forgot-password")}
          onClick={sendPasswordResetLink}
        >
          Forgot Password ?
        </p>
        {isChanges ? (
          <h5 className="">Password reset link sent to email.</h5>
        ) : null}
        <div
          style={{
            position: "absolute",
            bottom: "50px",
            fontSize: "20px",
          }}
        >
          v 1.0.0
        </div>
      </Form>
    </>
  );
};

export default Login;
